import { EChartService } from '@/service/echart/echart.service';
import DataTool from 'echarts/dist/extension/dataTool';
import { StatsNetwork } from '@/models/statistics/stats-network';

export class NetworkEChartService extends EChartService {
  xAxisLabels: string[];

  constructor(xAxisLabels: string[] = []) {
    super();
    this.series = [];
    this.xAxisLabels = xAxisLabels;
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  addSeries(data: StatsNetwork) {
    // 親のメソッド名との整合性と図更新の意味合いを合わせるため
    this.updateSeries(data);
  }

  updateSeries(data: StatsNetwork) {
    // ネットワークは一つの集団で表示するため、1要素とする
    this.series = [
      {
        // label: 'Network Graph',
        type: 'graph',
        layout: 'force',
        data: data.nodes,
        links: data.links,
        categories: data.categories,
        roam: true,
        label: {
          normal: {
            show: true,
            position: 'right',
          },
        },
        force: {
          repulsion: 250,
          edgeLength: 50,
        },
      },
    ];
  }

  get options() {
    return {
      title: {},
      tooltip: {},
      legend: [
        {
          data: this.xAxisLabels,
        },
      ],
      animation: false,
      series: this.series,
    };
  }
}
